import { render, staticRenderFns } from "./MaterialForm.vue?vue&type=template&id=164bb159&scoped=true&lang=html"
import script from "./MaterialForm.vue?vue&type=script&lang=js"
export * from "./MaterialForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164bb159",
  null
  
)

export default component.exports